export const GET_USERS = "GET_USERS";

export const ADD_COIN_TO_USERS_OPEN_DIALOGUE =
  "ADD_COIN_TO_USERS_OPEN_DIALOGUE";
export const ADD_COIN_TO_USERS_CLOSE_DIALOGUE =
  "ADD_COIN_TO_USERS_CLOSE_DIALOGUE";

export const UPDATE_USER = "UPDATE_USER";
